import React, { useState } from 'react';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { DateRangePicker } from 'react-date-range';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Container,
    FormGroup,
    Input,
    Label
} from "reactstrap";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ko } from 'date-fns/locale';
import { addDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

export default function LSPS() {
    const { t, i18n } = useTranslation();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [imageSrcs, setImageSrcs] = useState([]);
    const [imageTitles, setImageTitles] = useState([]);  // 이미지 제목을 저장할 state
    const yesterday= addDays(new Date(), -1);
    const [calendarPick, setCalendarPick] = useState([{
        startDate: yesterday,
        endDate: yesterday,
        key: 'selection'
    }]);
    const [isLoading, setIsLoading] = useState(false);
    
    const [buttonLabel, setButtonLabel] = useState('');
    const [dataTypeSelectionModalOpen, setDataTypeSelectionModalOpen] = useState(false);
    const [timeUnit, setTimeUnit] = useState('24');
    const [hour, setHour] = useState('0');
    const [viewMode, setViewMode] = useState('all');
    const [selectedDataType, setSelectedDataType] = useState(null);
    const titleMap = {
        rcvp: "Receiver",
        stnd: "Standalone",
        sbas_134: "SBAS PRN 134",
        sbas_137: "SBAS PRN 137",
        ssrr: "SSR"
    };

    const getTitleFullName = (titleKey) => {
        return titleMap[titleKey] || titleKey;  // 존재하지 않는 키에 대한 처리
    };

    const handleTimeUnitChange = (e) => {
        setTimeUnit(e.target.value);
    };

    const handleHourChange = (e) => {
        setHour(e.target.value);
    };

    const handleViewModeChange = (e) => {
        setViewMode(e.target.value);
    };

    const handleSelectedDataTypeChange = (e) => {
        setSelectedDataType(e.target.value);
    };

    const handleDateChange = (item) => {
        const newRange = { ...item.selection, endDate: item.selection.startDate };
        setCalendarPick([newRange]);
        setButtonLabel(formatDateString(item.selection.endDate));
        // setForceUpdateKey(prevKey => prevKey + 1);
    };

    const formatDateString = (date) => {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;  // getMonth()는 0에서 시작하므로 1을 더해준다.
        let day = date.getDate();
        // 각 구성 요소를 두 자리 숫자로 포맷팅
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;

        return `${year}-${month}-${day}`;
    };

    const getValue = () => {
        
        const chartType = viewMode === 'all' ? 'all' : selectedDataType;
        const isDaily = timeUnit === '24' ? '24' : hour;
        dateQuery(calendarPick[0].startDate, chartType, isDaily);
    };

    const dateQuery = async (startDate, chartType, isDaily) => {
        if (!chartType || (isDaily === '0' && hour === '')||!startDate) {
            alert('Please select all necessary options.');
            return;
        }
        setIsLoading(true);
        try {
            const formattedStartDate = formatDateString(startDate);
            
            const response = await axios.post('/accuracy', {
                startDate: formattedStartDate,
                chartType: chartType,
                isDaily: isDaily
            }, {
                baseURL: process.env.REACT_APP_SERVER_URL,
                responseType: 'json',
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.data) {
                const baseUrl = process.env.REACT_APP_SERVER_URL || 'https://intospace.co.kr';
                //console.log(response.data);
                if (Array.isArray(response.data)) {
                    // Handle array case
                    const webPaths = response.data.map(path =>
                        `${baseUrl}/images/${path}`
                    );
                    const titles = response.data.map(path => getTitleFullName(path.split('/')[1]));
                    // alert(webPaths);
                    // alert(titles);
                    setImageTitles(titles);  // 이미지 제목을 state에 저장
                    setImageSrcs(webPaths);
                } else {
                    const singlePath = `${baseUrl}/images/${response.data}`;
                    const singleTitle = getTitleFullName(response.data.split('/')[1]);
                    setImageTitles([singleTitle]);  // 이미지 제목을 state에 저장
                    setImageSrcs([singlePath]);
                }
            } else {
                console.error("No images received");
                setImageSrcs([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setImageSrcs([]);
        } finally {
            setIsLoading(false);
        }
    };
    // function openModal() {
    //     setIsOpen(true);
    // }

    // function closeModal() {
    //     setIsOpen(false);
    // }

    return (
        <div className="GraphContent">
            <div className="SearchContent">
                <div className="SearchArea">
                    <span className="searchText">{t('LoneSmart.Monitoring.QueryPeriod')} :</span>
                    <Button className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`} onClick={() => getValue()}>{t('LoneSmart.Monitoring.Yesterday')}</Button>
                    <Button id="lineRange" className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`} onClick={() => setIsOpen(true)}>{buttonLabel || t('LoneSmart.Monitoring.DateSelection')}</Button>
                    <Button className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`} onClick={() => setDataTypeSelectionModalOpen(true)}>{t('LoneSmart.Monitoring.DetailOptionSelect')}</Button>
    
            {/* Data Type Selection Modal */}
            <Modal open={dataTypeSelectionModalOpen}
                onClose={() => setDataTypeSelectionModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop} 
                BackdropProps={{
                timeout: 500,
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ position: 'fixed', top: '30vh' }}
             >
                <Fade in={dataTypeSelectionModalOpen}>
                    <Container style={{ backgroundColor: 'white', padding: '20px', borderRadius: '4px', boxShadow: '0px 2px 8px rgba(0,0,0,0.2)' }}>
                    <Card>
                        <CardHeader className="text-center">{t('LoneSmart.Monitoring.DataTypeSelection')}</CardHeader>
                        <CardBody>
                            <FormGroup>
                                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                    <Label className={`btn btn-secondary ${viewMode === 'all' ? 'active' : ''}`}>
                                        <Input type="radio" name="viewMode" id="viewAll" autoComplete="off"
                                            value="all" checked={viewMode === 'all'} onChange={handleViewModeChange} /> {t('LoneSmart.Monitoring.AllTypes')}
                                    </Label>
                                    <Label className={`btn btn-secondary ${viewMode === 'single' ? 'active' : ''}`}>
                                        <Input type="radio" name="viewMode" id="viewSingle" autoComplete="off"
                                            value="single" checked={viewMode === 'single'} onChange={handleViewModeChange} /> {t('LoneSmart.Monitoring.SingleType')}
                                    </Label>
                                </div>
                            </FormGroup>
                            {viewMode === 'single' && (
                                <FormGroup>
                                    {['RCVP', 'STND', 'SBAS_134', 'SBAS_137', 'SSRR'].map((dataType, index) => (
                                        <Label key={index} className={`btn btn-outline-primary ${selectedDataType === dataType ? 'active' : ''}`}>
                                            <Input type="radio" name="dataType" id={dataType}
                                                value={dataType} autoComplete="off" checked={selectedDataType === dataType}
                                                onChange={handleSelectedDataTypeChange} /> {dataType}
                                        </Label>
                                    ))}
                                </FormGroup>
                            )}
                        </CardBody>
                        <CardBody>
                            <FormGroup>
                                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                    <Label className={`btn btn-secondary ${timeUnit === '24' ? 'active' : ''}`}>
                                        <Input type="radio" name="timeUnit" id="twentyFourHours" autoComplete="off"
                                            value="24" checked={timeUnit === '24'} onChange={handleTimeUnitChange} /> {t('LoneSmart.Monitoring.HourUnit24')}
                                    </Label>
                                    <Label className={`btn btn-secondary ${timeUnit === '1' ? 'active' : ''}`}>
                                        <Input type="radio" name="timeUnit" id="oneHour" autoComplete="off"
                                            value="1" checked={timeUnit === '1'} onChange={handleTimeUnitChange} /> {t('LoneSmart.Monitoring.HourUnit1')}
                                    </Label>
                                </div>
                                {timeUnit === '1' && (
                                    <FormGroup>
                                        <select className="form-control" value={hour} onChange={handleHourChange}>
                                            {Array.from({ length: 24 }, (_, i) => (
                                                <option key={i} value={i}>{t('LoneSmart.Monitoring.HourLabel', { hour: i })}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                )}
                            </FormGroup>
                        </CardBody>
                        <CardFooter className="text-center">
                            <Button className="modalBtn itsBtnDefault" onClick={() => {setDataTypeSelectionModalOpen(false);getValue()}}>
                                        {t('LoneSmart.Monitoring.Search')}
                                    </Button>
                            <Button className="modalBtn itsBtnGray" onClick={() => setDataTypeSelectionModalOpen(false)}>{t('LoneSmart.Monitoring.Close')}</Button>
                        </CardFooter>
                    </Card>
                    </Container>
                </Fade>
            </Modal>
            
                    <Modal
                    open={modalIsOpen}
                    // onClose={closeModal}
                    onClose={() => setIsOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ position: 'fixed', top: '30vh' }}
                >
                    <Fade in={modalIsOpen}>
                        <Container
                            direction="column"
                            // alignItems="center"
                            justifyContent="center"
                            style={{ width: 'fit-content' }}
                        >
                            <Card>
                                <CardHeader>Calendar</CardHeader>
                                <CardBody>
                                    <DateRangePicker
                                        locale={ko}
                                        // key={forceUpdateKey} // Use key to force re-render if necessary
                                        onChange={handleDateChange}
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={1}
                                        ranges={calendarPick}
                                        direction="horizontal"
                                        maxDate={addDays(new Date(), -1)}
                                    />
                                    <CardFooter>
                                    <Button className="modalBtn itsBtnDefault" onClick={() => {setIsOpen(false);getValue()}}>
                                            조회
                                        </Button>
                                        {/* <Button className="modalBtn itsBtnGray" onClick={closeModal}>
                                            닫기
                                        </Button> */}
                                        <Button className="modalBtn itsBtnGray" onClick={() => setIsOpen(false)}>닫기</Button>
                                    </CardFooter>
                                </CardBody>
                            </Card>
                        </Container>
                    </Fade>
                </Modal>
                </div>
            </div>
            <div className="searchExampleText" style={{ 
                gap: '5px', textAlign:'center'}}>
                <div>{t('LoneSmart.Monitoring.SelectPeriodMessage')}</div>
                <div>{t('LoneSmart.Monitoring.DailyGraphNote1')}</div>
                <div>{t('LoneSmart.Monitoring.DailyGraphNote2')}</div>
            </div>
            
            
            
             <div className="GraphContent">
            {/* SearchContent and Modal components... */}
                {isLoading &&
                    // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                    <div className="loader">
                        <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                        </div>
                    </div>
                }
            <Grid container spacing={3} justifyContent="center">
                {imageSrcs.map((src, index) => (
                    // <Grid item xs={12} sm={4} md={4} lg={4} key={index}>
                    // <Grid item xs={imageSrcs.length === 1 ? 12 : 6} sm={imageSrcs.length === 1 ? 8 : 4} md={imageSrcs.length === 1 ? 8 : 4} lg={imageSrcs.length === 1 ? 8 : 4} key={index}>
                    <Grid item
                    {...(imageSrcs.length === 1
                        ? { xs: 12, sm: 12, md: 10, lg: 8,  xl: 8 }
                        // 여러 장: xs/sm=1열, md/lg=2열, xl=3열
                        : { xs: 12, sm: 12, md: 6,  lg: 6,  xl: 4 })}
                    key={index}
                    >
                        <Card>
                            <CardBody>
                                {/* <div style={{ display: 'flex', flexDirection: 'column', 
                                // alignItems: 'center' 
                                }}> */}
                                    {/* {titles[index]} */}
                                    {/* <img src={src} alt={`Image ${index}`} style={{ width: '100%', height: 'auto' }} /> */}
                                    
                                    
                                    <img src={src}  alt={`Data visualization of ${imageTitles[index]}`} style={{ width: imageSrcs.length === 1 ? '100%' : '100%', height: 'auto' }} />
                                    <div className="searchExampleText" style={{ gap: '5px',textAlign:'center'}}>{imageTitles[index]}</div>
                                {/* </div> */}
                            </CardBody>
                            <CardFooter>
                                
                            </CardFooter>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            
        </div>
          
        </div>
    );
}
